import { render, staticRenderFns } from "./ProrrogacoesOuvidoria.vue?vue&type=template&id=d7435d52&scoped=true"
import script from "./ProrrogacoesOuvidoria.vue?vue&type=script&lang=ts"
export * from "./ProrrogacoesOuvidoria.vue?vue&type=script&lang=ts"
import style0 from "./ProrrogacoesOuvidoria.vue?vue&type=style&index=0&id=d7435d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7435d52",
  null
  
)

export default component.exports